import { useState } from "react";
import wmtLogo from "@/assets/wmt-logo.png";
import LegalHub from "@/components/LegalHub";
import SocialLinks from "@/components/SocialLinks";
import { footerNavigationItems } from "@/config/navigation";
import { COOKIE_SETTINGS_EVENT } from "@/lib/cookieConsent";

const FooterNavigation = () => (
  <nav aria-label="Навигация в подвале" className="grid w-full grid-cols-3 gap-x-3 gap-y-2.5">
    {footerNavigationItems.map((item) => {
      const external = /^https?:\/\//.test(item.href);
      return (
        <a
          key={`${item.label}-${item.href}`}
          href={item.href}
          {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
          className="text-[12px] leading-snug text-muted-foreground transition-colors hover:text-accent"
        >
          {item.label}
        </a>
      );
    })}
  </nav>
);

const Footer = () => {
  const [legalOpen, setLegalOpen] = useState(false);

  return (
    <footer id="footer" className="border-t border-border py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Mobile: stacked center-aligned */}
        <div className="flex flex-col items-start gap-6 sm:hidden">
          <FooterNavigation />
          <SocialLinks />
          <div className="flex items-center gap-3">
            <img src={wmtLogo} alt="WMT AI" className="h-6 w-auto opacity-70" />
            <span className="text-xs text-muted-foreground">
              © {new Date().getFullYear()} WMT AI
            </span>
          </div>
          <button
            onClick={() => setLegalOpen(true)}
            className="text-xs text-muted-foreground/60 hover:text-muted-foreground transition-colors"
          >
            Правовая информация
          </button>
          <p className="max-w-xs text-left text-[11px] leading-relaxed text-muted-foreground/70">
            Компания, специализирующаяся на внедрении искусственного интеллекта в бизнес-процессы.
          </p>
          <div className="max-w-sm text-left text-xs leading-relaxed text-muted-foreground">
            <p>Оператор основных форм: ООО «ИИгорь», ИНН 7725743052, ОГРН 5117746027779.</p>
            <div className="mt-2 flex flex-col items-start gap-1">
              <a href="/legal/privacy-policy/" className="block whitespace-nowrap underline underline-offset-2">Политика обработки персональных данных</a>
              <a href="/legal/personal-data-consent/" className="block whitespace-nowrap underline underline-offset-2">Согласие на обработку данных</a>
              <button type="button" onClick={() => window.dispatchEvent(new Event(COOKIE_SETTINGS_EVENT))} className="block whitespace-nowrap underline underline-offset-2">Настройки cookie</button>
            </div>
          </div>
        </div>

        {/* Desktop: 3-column grid */}
        <div className="hidden sm:grid sm:grid-cols-3 items-center">
          <div className="flex flex-col items-start gap-1">
            <div className="flex items-center gap-3">
              <img src={wmtLogo} alt="WMT AI" className="h-7 w-auto" />
              <span className="text-xs text-muted-foreground">
                © {new Date().getFullYear()} WMT AI. Все права защищены.
              </span>
            </div>
            <button
              onClick={() => setLegalOpen(true)}
              className="text-xs text-muted-foreground/60 hover:text-muted-foreground transition-colors ml-10"
            >
              Правовая информация
            </button>
            <p className="text-[11px] text-muted-foreground/70 ml-10 mt-2 max-w-xs leading-relaxed">
              Компания, специализирующаяся на внедрении искусственного интеллекта в бизнес-процессы.
            </p>
            <div className="ml-10 mt-3 max-w-sm text-left text-xs leading-relaxed text-muted-foreground">
              <p>Оператор основных форм: ООО «ИИгорь», ИНН 7725743052, ОГРН 5117746027779.</p>
              <div className="mt-2 flex flex-col items-start gap-1">
                <a href="/legal/privacy-policy/" className="block whitespace-nowrap underline underline-offset-2">Политика обработки персональных данных</a>
                <a href="/legal/personal-data-consent/" className="block whitespace-nowrap underline underline-offset-2">Согласие на обработку данных</a>
                <button type="button" onClick={() => window.dispatchEvent(new Event(COOKIE_SETTINGS_EVENT))} className="block whitespace-nowrap underline underline-offset-2">Настройки cookie</button>
              </div>
            </div>
          </div>

          <SocialLinks className="flex items-center justify-center gap-5" />

          <div className="w-full max-w-[360px] justify-self-end">
            <FooterNavigation />
          </div>
        </div>
      </div>

      <LegalHub open={legalOpen} onOpenChange={setLegalOpen} />
    </footer>
  );
};

export default Footer;
